import React from 'react';
import { TABS } from '../../hooks/useTabNavigation';

const TAB_CONFIG = [
  { id: TABS.CARDS, label: 'Cards', icon: 'credit_card' },
  { id: TABS.FLIGHTS, label: 'Flights', icon: 'flight_takeoff' },
  { id: TABS.LOYALTY, label: 'Loyalty', icon: 'stars' },
  { id: TABS.MORE, label: 'More', icon: 'more_horiz' },
];

function BottomNavBar({ activeTab, onTabChange }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/85 backdrop-blur-3xl border-t border-outline-variant/8 shadow-nav">
      <div className="flex items-center justify-around px-2 pb-safe-bottom h-16">
        {TAB_CONFIG.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className="flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-all"
            >
              <div className={`flex items-center justify-center w-16 h-8 rounded-full transition-all ${
                isActive ? 'bg-primary-light' : ''
              }`}>
                <span className={`material-symbols-outlined text-[22px] ${
                  isActive ? 'filled text-primary' : 'text-on-surface-variant'
                }`}>
                  {tab.icon}
                </span>
              </div>
              <span className={`text-[11px] font-semibold ${
                isActive ? 'text-primary' : 'text-on-surface-variant'
              }`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNavBar;
